module.exports = __webpack_public_path__ + "img/family.f7ab5cf5.jpg";